module.exports = __webpack_public_path__ + "static/img/join_10.b01f2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_10.png
// module id = K+bW
// module chunks = 0